function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4002 23.9168V21.6001H20.9921V23.8866H21.8358L20.1657 25.7742H19.4741V23.8866H20.425V21.6001H19.1422V22.4584H18.4471V21.6001H17.1781V22.4584H16.4831V21.6001H15.2002V23.9168H16.3344V26.8001V29.6834H15.2002V32.0001H20.425V29.7136H19.4741V27.826H20.1657L21.8358 29.7136H20.9921V32.0001H26.4002V29.6834H25.5599L23.0115 26.8001L25.5599 23.9168H26.4002Z",
  fill: "#48DBB4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.8 14.2153H3.2V47.3846H60.8V14.2153ZM3.2 11.2C1.43269 11.2 0 12.55 0 14.2153V47.3846C0 49.0499 1.43269 50.4 3.2 50.4H60.8C62.5673 50.4 64 49.0499 64 47.3846V14.2153C64 12.55 62.5673 11.2 60.8 11.2H3.2Z",
  fill: "#0A0806"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.6001 42.4C1.6001 41.5164 2.32587 40.8 3.22115 40.8H61.579C62.4743 40.8 63.2001 41.5164 63.2001 42.4C63.2001 43.2837 62.4743 44 61.579 44H3.22115C2.32587 44 1.6001 43.2837 1.6001 42.4Z",
  fill: "#0A0806"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.3999 60.9454C22.3999 59.9814 23.1814 59.2 24.1454 59.2L39.8544 59.1999C40.8184 59.1999 41.5999 59.9814 41.5999 60.9454C41.5999 61.9094 40.8184 62.6909 39.8544 62.6909L24.1454 62.6909C23.1814 62.6909 22.3999 61.9094 22.3999 60.9454Z",
  fill: "#0A0806"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.9999 60.8C27.1162 60.8 26.3999 59.9814 26.3999 58.9715L26.3999 49.8286C26.3999 48.8187 27.1162 48 27.9999 48C28.8836 48 29.5999 48.8187 29.5999 49.8286L29.5999 58.9715C29.5999 59.9814 28.8836 60.8 27.9999 60.8Z",
  fill: "#0A0806"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.9999 60.8C35.1162 60.8 34.3999 59.9735 34.3999 58.9539L34.3999 50.6462C34.3999 49.6266 35.1162 48.8 35.9999 48.8C36.8836 48.8 37.5999 49.6266 37.5999 50.6462L37.5999 58.9539C37.5999 59.9735 36.8836 60.8 35.9999 60.8Z",
  fill: "#0A0806"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6001 23.9999C33.6001 23.1162 34.3164 22.3999 35.2001 22.3999H48.0001C48.8838 22.3999 49.6001 23.1162 49.6001 23.9999C49.6001 24.8836 48.8838 25.5999 48.0001 25.5999H35.2001C34.3164 25.5999 33.6001 24.8836 33.6001 23.9999Z",
  fill: "#0A0806"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6001 29.6C33.6001 28.7163 34.3164 28 35.2001 28H39.2001C40.0838 28 40.8001 28.7163 40.8001 29.6C40.8001 30.4837 40.0838 31.2 39.2001 31.2H35.2001C34.3164 31.2 33.6001 30.4837 33.6001 29.6Z",
  fill: "#0A0806"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.39995C12 3.73721 12.5373 3.19995 13.2 3.19995H19.6C20.2627 3.19995 20.8 3.73721 20.8 4.39995C20.8 5.06269 20.2627 5.59995 19.6 5.59995H13.2C12.5373 5.59995 12 5.06269 12 4.39995Z",
  fill: "#48DBB4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52 59.5999C52 58.9372 52.5373 58.3999 53.2 58.3999H59.6C60.2627 58.3999 60.8 58.9372 60.8 59.5999C60.8 60.2626 60.2627 60.7999 59.6 60.7999H53.2C52.5373 60.7999 52 60.2626 52 59.5999Z",
  fill: "#48DBB4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4001 -5.72222e-08C17.0628 -2.56192e-08 17.6001 0.537258 17.6001 1.2L17.6001 7.6C17.6001 8.26274 17.0628 8.8 16.4001 8.8C15.7374 8.8 15.2001 8.26274 15.2001 7.6L15.2001 1.2C15.2001 0.537258 15.7374 -8.88251e-08 16.4001 -5.72222e-08Z",
  fill: "#48DBB4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.4001 55.2C57.0628 55.2 57.6001 55.7372 57.6001 56.4L57.6001 62.8C57.6001 63.4627 57.0628 64 56.4001 64C55.7374 64 55.2001 63.4627 55.2001 62.8L55.2001 56.4C55.2001 55.7372 55.7374 55.2 56.4001 55.2Z",
  fill: "#48DBB4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.3999 29.6C42.3999 28.7163 43.1162 28 43.9999 28H44.7999C45.6836 28 46.3999 28.7163 46.3999 29.6C46.3999 30.4837 45.6836 31.2 44.7999 31.2H43.9999C43.1162 31.2 42.3999 30.4837 42.3999 29.6Z",
  fill: "#0A0806"
});

const SvgDashboard = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.d904014f.svg";
export { ForwardRef as ReactComponent };